(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'delaferia_cookie_consent';
    var banner = document.getElementById('cookie-consent-banner');
    var acceptBtn = document.getElementById('cookieAccept');
    var rejectBtn = document.getElementById('cookieReject');

    function loadGTM() {
      if (window.__gtmLoaded) return;
      window.__gtmLoaded = true;
      (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-K6BR4GJQ');

      var ns = document.createElement('noscript');
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-K6BR4GJQ';
      iframe.height = 0; iframe.width = 0; iframe.style.display = 'none'; iframe.style.visibility = 'hidden';
      ns.appendChild(iframe);
      document.body.insertBefore(ns, document.body.firstChild);
    }

    var stored = null;
    try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) {}

    if (stored === 'accepted') {
      loadGTM();
    } else if (stored !== 'rejected' && banner) {
      banner.hidden = false;
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        try { localStorage.setItem(STORAGE_KEY, 'accepted'); } catch (e) {}
        banner.hidden = true;
        loadGTM();
      });
    }
    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        try { localStorage.setItem(STORAGE_KEY, 'rejected'); } catch (e) {}
        banner.hidden = true;
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    const modal = document.querySelector('[data-quick-view-modal]');
    if (!modal) return;
    const loading = modal.querySelector('[data-quick-view-loading]');
    const content = modal.querySelector('[data-quick-view-content]');
    let currentProduct = null;

    const money = (cents) => {
      const val = (cents / 100).toLocaleString('es-CL', { minimumFractionDigits: 0 });
      return '$' + val;
    };

    // Normalizar URL de imagen: agregar https: si empieza con //, y manejar objeto/string
    const escapeHtml = (str) => String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    const imgUrl = (img) => {
      if (!img) return '';
      let url = typeof img === 'string' ? img : (img.src || img.url || '');
      if (!url) return '';
      if (url.startsWith('//')) url = 'https:' + url;
      return url;
    };

    const openModal = () => {
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('quick-view-open');
    };
    const closeModal = () => {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('quick-view-open');
    };

    const renderProduct = (product) => {
      currentProduct = product;
      const featuredRaw = product.featured_image || (product.images && product.images[0]) || '';
      const featured = imgUrl(featuredRaw);
      const images = (product.images && product.images.length ? product.images : [featuredRaw])
        .map(imgUrl)
        .filter(Boolean);
      const hasCompare = product.compare_at_price > product.price;
      const discount = hasCompare ? Math.round((1 - product.price / product.compare_at_price) * 100) : 0;
      const descText = (product.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 400);

      const variantOpts = product.variants.length > 1 ? `
        <div class="qv-variants">
          <span class="qv-variants__label">${product.options && product.options[0] ? product.options[0].name || product.options[0] : 'Opciones'}</span>
          <div class="qv-variants__options" data-qv-variants>
            ${product.variants.map((v, i) => `
              <button type="button"
                class="qv-variants__option ${i === 0 ? 'is-active' : ''}"
                data-variant-id="${v.id}"
                data-variant-price="${v.price}"
                ${v.available ? '' : 'disabled'}>${v.title}</button>
            `).join('')}
          </div>
        </div>` : '';

      content.innerHTML = `
        <div class="qv-gallery">
          <div class="qv-gallery__main"><img id="qvMainImg" src="${featured}" alt="${escapeHtml(product.title)}"></div>
          ${images.length > 1 ? `
            <div class="qv-gallery__thumbs">
              ${images.map((img, i) => `
                <button type="button" class="qv-gallery__thumb ${i === 0 ? 'is-active' : ''}" data-thumb="${img}">
                  <img src="${img}" alt="">
                </button>`).join('')}
            </div>` : ''}
        </div>
        <div class="qv-info">
          ${product.vendor ? `<p class="qv-info__vendor">${escapeHtml(product.vendor)}</p>` : ''}
          <h2 class="qv-info__title" id="qvTitle">${escapeHtml(product.title)}</h2>
          <div class="qv-info__price">
            <span class="qv-info__price-now" data-qv-price>${money(product.price)}</span>
            ${hasCompare ? `<span class="qv-info__price-was">${money(product.compare_at_price)}</span><span class="qv-info__badge-sale">-${discount}%</span>` : ''}
          </div>
          ${descText ? `<p class="qv-info__desc">${escapeHtml(descText)}${descText.length >= 400 ? '…' : ''}</p>` : ''}
          ${variantOpts}
          <div class="qv-actions">
            <button type="button" class="qv-actions__add" data-qv-add data-variant-id="${product.variants[0].id}" ${product.available ? '' : 'disabled'}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
              <span>${product.available ? 'Agregar al carro' : 'Agotado'}</span>
            </button>
            <a href="/products/${product.handle}" class="qv-actions__link">Ver detalle completo →</a>
          </div>
        </div>
      `;

      // Thumbs
      content.querySelectorAll('[data-thumb]').forEach(btn => {
        btn.addEventListener('click', () => {
          content.querySelectorAll('.qv-gallery__thumb').forEach(t => t.classList.remove('is-active'));
          btn.classList.add('is-active');
          content.querySelector('#qvMainImg').src = btn.getAttribute('data-thumb');
        });
      });

      // Variant selection — cambia precio + IMAGEN + thumb activo
      content.querySelectorAll('[data-qv-variants] .qv-variants__option').forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          content.querySelectorAll('[data-qv-variants] .qv-variants__option').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const vid = btn.getAttribute('data-variant-id');
          const vprice = btn.getAttribute('data-variant-price');
          content.querySelector('[data-qv-add]').setAttribute('data-variant-id', vid);
          content.querySelector('[data-qv-price]').textContent = money(vprice);

          // Cambiar imagen principal a la de la variante (si tiene featured_image)
          const variant = currentProduct.variants.find(v => v.id === parseInt(vid, 10));
          const newImg = variant ? imgUrl(variant.featured_image) : '';
          if (newImg) {
            const mainImg = content.querySelector('#qvMainImg');
            if (mainImg) mainImg.src = newImg;
            // Sync thumb activo si esa imagen está en los thumbs
            content.querySelectorAll('[data-thumb]').forEach(t => {
              const isMatch = t.getAttribute('data-thumb') === newImg;
              t.classList.toggle('is-active', isMatch);
            });
          }
        });
      });

      // Add to cart
      content.querySelector('[data-qv-add]').addEventListener('click', async (e) => {
        const btn = e.currentTarget;
        const vid = btn.getAttribute('data-variant-id');
        btn.disabled = true;
        btn.querySelector('span').textContent = 'Agregando…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
          });
          if (res.ok) {
            document.querySelector('[data-qv-success]').classList.add('is-visible');
            btn.querySelector('span').textContent = '✓ Agregado';
            setTimeout(() => {
              btn.disabled = false;
              btn.querySelector('span').textContent = 'Agregar al carro';
              document.querySelector('[data-qv-success]').classList.remove('is-visible');
            }, 2500);
            // Actualizar contador del carrito si existe
            const cartCount = document.querySelector('[data-cart-count]');
            if (cartCount) {
              const c = await fetch('/cart.js').then(r => r.json());
              cartCount.textContent = c.item_count;
            }
          } else {
            throw new Error('Error');
          }
        } catch (err) {
          btn.disabled = false;
          btn.querySelector('span').textContent = 'Reintentar';
        }
      });

    };

    const loadProduct = async (handle) => {
      // Limpiar contenido viejo y forzar ocultar
      content.innerHTML = '';
      content.style.display = 'none';
      content.hidden = true;
      loading.hidden = false;
      loading.style.display = '';
      loading.innerHTML = '<div class="quick-view__spinner"></div><p>Cargando producto…</p>';
      openModal();
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const product = await res.json();
        try {
          renderProduct(product);
          // Solo mostrar si render funcionó
          loading.hidden = true;
          loading.style.display = 'none';
          content.hidden = false;
          content.style.display = '';
        } catch (renderErr) {
          console.error('QuickView render error:', renderErr);
          loading.innerHTML = '<p style="color:#c00">No se pudo mostrar la vista previa. <a href="/products/' + handle + '" style="color:#0F5A4E;font-weight:700">Ver detalle completo →</a></p>';
        }
      } catch (err) {
        console.error('QuickView fetch error:', err);
        loading.innerHTML = '<p style="color:#c00">No se pudo cargar el producto. <a href="/products/' + handle + '" style="color:#0F5A4E;font-weight:700">Ir a la página del producto →</a></p>';
      }
    };

    // Delegación de eventos: cualquier [data-quick-view]
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-view]');
      if (trigger) {
        e.preventDefault();
        const handle = trigger.getAttribute('data-quick-view');
        loadProduct(handle);
        return;
      }
      const closer = e.target.closest('[data-quick-view-close]');
      if (closer) {
        e.preventDefault();
        closeModal();
      }
    });

    // ESC para cerrar
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
